/**
 * Copyright (c) 2024 TechDivision GmbH
 * All rights reserved
 *
 * This product includes proprietary software developed at TechDivision GmbH, Germany
 * For more information see https://www.techdivision.com/
 *
 * To obtain a valid license for using this software please contact us at
 * license@techdivision.com
 *
 * @author Sebastian Hartmann <s.hartmann@techdivision.com>
 */
import React from 'react';
import './styles.scss';
import { Box } from '@mui/material';
import PropTypes from 'prop-types';
import moment from 'moment';
import { useTranslation } from 'react-i18next';

/**
 * OpeningHour Component
 * @param props
 * @returns {Element}
 * @constructor
 */
export function OpeningHour(props) {
  const { day, from, to } = props;
  const { t } = useTranslation();

  return (
    <Box className="opening-row" mb="3px">
      <span>
        {t(day.toLowerCase())}
        :
        {' '}
        {moment(from, 'HH:mm:ss').format('HH:mm').toString()}
        {' '}
        -
        {' '}
        {moment(to, 'HH:mm:ss').format('HH:mm').toString()}
        {' '}
        {t('clock')}
      </span>
    </Box>
  );
}

OpeningHour.propTypes = {
  day: PropTypes.string.isRequired,
  from: PropTypes.string.isRequired,
  to: PropTypes.string.isRequired,
};
